const mapStrings = {
  BICYCLE_OVERLAY: 'bicycleOverlay',
  TRANSIT_OVERLAY: 'transitOverlay',
  NO_OVERLAY: 'none',
};

const overlays = [mapStrings.BICYCLE_OVERLAY, mapStrings.TRANSIT_OVERLAY, mapStrings.NO_OVERLAY];

const mapTypeStrings = {
  DEFAULT: 'default',
  SATELLITE: 'satellite',
};

const mapTypes = [mapTypeStrings.DEFAULT, mapTypeStrings.SATELLITE];

// Timing constants
const BOUNDS_DEBOUNCE_MS = 250;
const RESIZE_DEBOUNCE_MS = 800;
const IDLE_TIMEOUT_DELAY_MS = 500; // minimum time before fetchListings will be called
const CLICK_DELAY_MS = 250; // delay for single click detection

// Layout constants
const HEADER_OFFSET_PX = 42 + 48; // 42px NavBar, 48px FilterNav
const PREVIEW_OFFSET_PX = 200 + 30; // 200px high ListingPreview, 30px padding above

const UNITED_STATES_RESOURCE_ID = 'united-states';
const LAT_LON_PRECISION = 4; // Decimal precision

const mapConstants = {
  ...mapStrings,
  ...mapTypeStrings,
  MAP_TYPES: mapTypes,
  OVERLAYS: overlays,
  ID: '751c42f5dfd15580',
  BOUNDS_DEBOUNCE_MS,
  RESIZE_DEBOUNCE_MS,
  IDLE_TIMEOUT_DELAY_MS,
  CLICK_DELAY_MS,
  HEADER_OFFSET_PX,
  PREVIEW_OFFSET_PX,
  UNITED_STATES_RESOURCE_ID,
  LAT_LON_PRECISION,
};

export default mapConstants;
